import { Button, Form, Modal, notification, Select } from "antd";
import React, { useEffect, useState } from "react";
import { FaShareAlt } from "react-icons/fa";
import { postShareFiles } from "../../../services/api-calls/draft-files.api";

const FileShare = ({ chapterName, bookName, project, users, chunkName }) => {
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentProject, setCurrentProject] = useState();
  const [selectedBookName, setSelectedBookName] = useState();
  const [seleectedChapterName, setSeleectedChapterName] = useState();
  const [otherUsers, setOtherUsers] = useState([]);
  const [backUpUsers, setBackUpUsers] = useState([]);
  const [targetTypeSelection, setTargetTypeSelection] = useState("draft");
  const [shareUserRole, setShareUserRole] = useState([]);

  const [api, contextHolder] = notification.useNotification();
  const showNotifications = (type, message) => {
    notification.destroy();
    api[type]({
      message,
      placement: "top",
    });
  };

  useEffect(() => {
    form.resetFields(["shareType"]);
    // form.setFieldValue("userType", "MTT");

    if (project) setCurrentProject(project);
    if (bookName) setSelectedBookName(bookName);
    if (chapterName) setSeleectedChapterName(chapterName);
    if (users) {
      setOtherUsers(users);
      setBackUpUsers(users);
    }

    if (localStorage.getItem("role") == "Facilitator") {
      setShareUserRole([
        { value: "Community", label: `Community` },
        { value: "Facilitator", label: `Facilitator` },
        { value: "CIT", label: `CIT` },
        { value: "Consultant", label: `Consultant` },
      ]);
    } else {
      setShareUserRole([
        { value: "CIT", label: `CIT` },
        { value: "Consultant", label: `Consultant` },
      ]);
    }

    return () => {
      setCurrentProject({});
      setSelectedBookName("");
      setSeleectedChapterName("");
      setOtherUsers([]);
    };
  }, [users]);

  const onFinish = async (data) => {
    try {
      setIsLoading(true);
      console.log("targetTypeSelection", targetTypeSelection);
      console.log(
        data.userType,
        data.userType == "Community" || data.userType == "MTT"
      );
      let body = {
        ...data,
        ...{
          bookName: selectedBookName,
          chapterName: seleectedChapterName,
          projectId: currentProject._id,
          sender: localStorage.getItem("id"),
          chunkName,
          userRole: data.userType
            ? data.userType
            : localStorage.getItem("role"),
          targetType: targetTypeSelection,
        },
      };

      console.log("body -- ", body);

      let res = await postShareFiles(body);
      if (navigator?.share) {
        const sharedFileUrl = `${window.location.protocol}//${window.location.host}/shared-files/${res?.sharedFiles?._id}`;

        navigator
          .share({
            title: "File Sharing",
            url: sharedFileUrl,
          })
          .then(() => console.log("File shared successfully"))
          .catch((error) => console.error("Error sharing file:", error));
      } else {
        console.error("Web Share API is not supported in this browser.");
      }

      form.resetFields();
      showNotifications("success", "Files shared successfully");
      setIsModalOpen(false);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      showNotifications(
        "error",
        error &&
          error.response &&
          error.response.data &&
          error.response.data.error
          ? error.response.data.error
          : "Something went wrong"
      );
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onCancel = (e) => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const handleUserSelection = (role) => {
    try {
      setTargetTypeSelection(role);
      form.setFieldValue("receiver", null);

      let roleUsers = backUpUsers.filter((user) => user.role == role);
      setOtherUsers(roleUsers);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <span className="flex items-center">
        <FaShareAlt
          size="20"
          color="gray"
          className="mr-2"
          onClick={(e) => {
            setIsModalOpen(true);
          }}
        />
      </span>

      <Modal
        title={"Share File"}
        open={isModalOpen}
        footer={<></>}
        onClose={onCancel}
        onCancel={onCancel}
      >
        <div className="mb-2">
          <p className="heading capitalize">
            Project Name:
            {currentProject && currentProject.projectName
              ? `  ${project.projectName}`
              : ""}
          </p>
          <p className="heading capitalize">Book : {selectedBookName}</p>
          {seleectedChapterName ? (
            <p className="heading capitalize">
              Chapter: {seleectedChapterName}
            </p>
          ) : null}
          {chunkName ? (
            <p className="heading capitalize">Chunk Name: {chunkName}</p>
          ) : null}
        </div>

        <Form
          form={form}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          requiredMark="optional"
        >
          {localStorage.getItem("role") == "Facilitator" ||
          localStorage.getItem("role") == "CIT" ||
          localStorage.getItem("role") == "Consultant" ? (
            <Form.Item
              className="w-full"
              label={
                <span style={{ fontWeight: "600", marginBottom: "0px" }}>
                  Sharing To
                </span>
              }
              name="userType"
              rules={[{ required: true, message: `Please select user type` }]}
            >
              <Select
                showSearch
                disabled={isLoading}
                onChange={handleUserSelection}
                className="w-full"
                optionFilterProp="children"
                placeholder={"Please select user type"}
                options={shareUserRole}
              />
            </Form.Item>
          ) : null}
          <Form.Item
            className="w-full"
            label={<span style={{ fontWeight: "600" }}>User</span>}
            name="receiver"
            rules={[{ required: true, message: `Please select user` }]}
          >
            <Select
              showSearch
              className="w-full"
              disabled={isLoading}
              optionFilterProp="children"
              placeholder="Please select share option"
            >
              {otherUsers && otherUsers.length > 0 ? (
                <>
                  {otherUsers.map((user) => (
                    <Select.Option value={user._id}>
                      <span> {user.firstName}</span>
                      <span className="mx-2"> {user.lastName}</span>
                      <span className="mx-2">( {user.role})</span>
                    </Select.Option>
                  ))}
                </>
              ) : null}
            </Select>
          </Form.Item>

          <Form.Item
            className="w-full"
            disabled={isLoading}
            label={<span style={{ fontWeight: "600" }}>Share Option</span>}
            name="shareType"
            rules={[{ required: true, message: `Please select share option` }]}
          >
            <Select
              showSearch
              className="w-full"
              style={{ marginTop: "-7px" }}
              optionFilterProp="children"
              placeholder={"Please select share option"}
              options={[
                { value: "email", label: `Email` },
                { value: "sms", label: `SMS` },
                { value: "others", label: `Others` },
              ]}
            />
          </Form.Item>

          <div className="w-full flex flex-row mt-4">
            <Button
              htmlType="button"
              disabled={isLoading}
              className="submit-btn w-full mr-2"
              danger
              style={{
                background: "red",
                color: "white",
                borderColor: "red",
              }}
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              htmlType="submit"
              loading={isLoading}
              className="submit-btn w-full ml-2"
              style={{
                background: "#031832",
                color: "white",
                borderColor: "#031832",
              }}
            >
              Submit
            </Button>
          </div>
        </Form>
      </Modal>

      {contextHolder}
    </div>
  );
};

export default FileShare;
